import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {AuthSessionRecoveryService} from './auth-session-recovery.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
	private recoveryService: AuthSessionRecoveryService | null = null;

	constructor(private injector: Injector) {
	}

	intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				if (!this.isUnauthorizedSessionError(error, req)) {
					return throwError(() => error);
				}

				return this.getRecoveryService().handleSessionLost().pipe(
					switchMap(recovered => {
						if (recovered) {
							return next.handle(req);
						}
						return throwError(() => error);
					}),
				);
			}),
		);
	}

	private getRecoveryService(): AuthSessionRecoveryService {
		if (!this.recoveryService) {
			this.recoveryService = this.injector.get(AuthSessionRecoveryService);
		}
		return this.recoveryService;
	}

	private isUnauthorizedSessionError(error: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
		if (error.status !== 401) {
			return false;
		}
		if (req.headers.has('X-Skip-Auth-Recovery')) {
			return false;
		}
		const url = req.url;
		return !url.includes('/auth/login')
			&& !url.includes('/auth/logout')
			&& !url.includes('/auth/register')
			&& !url.includes('/auth/request-pass')
			&& !url.includes('/auth/reset-pass');
	}
}
